module.exports = __webpack_public_path__ + "img/home.3686c7f7.jpg";